import Typekey from '@/userManagement/Typekey';

export default class StateType extends Typekey {
  static readonly andraPradesh = new StateType('andraPradesh', 'Andra Pradesh', '');

  static readonly arunachalPradesh = new StateType('arunachalPradesh', 'Arunachal Pradesh', '');

  static readonly goa = new StateType('goa', 'Goa', '');

  static readonly karnataka = new StateType('karnataka', 'Karnataka', '');

  static readonly telangana = new StateType('telangana', 'Telangana', '');

  static readonly kerala = new StateType('kerala', 'Kerala', '');

  static readonly tamilNadu = new StateType('tamilNadu', 'Tamil Nadu', '');

  static readonly tripura = new StateType('tripura', 'Tripura', '');

  static readonly rajasthan = new StateType('rajasthan', 'Rajasthan', '');

  static readonly bihar = new StateType('bihar', 'Bihar', '');

  static readonly haryana = new StateType('haryana', 'Haryana', '');

  static readonly himachalPradesh = new StateType('himachalPradesh', 'Himachal Pradesh', '');

  static readonly madhyaPradesh = new StateType('madhyaPradesh', 'Madhya Pradesh', '');

  static readonly westBengal = new StateType('westBengal', 'West Bengal', '');

  static readonly updateState = new StateType('updateState', 'Update State', '');

  static allStates() {
    return [
      StateType.andraPradesh,
      StateType.arunachalPradesh,
      StateType.karnataka,
      StateType.telangana,
      StateType.kerala,
      StateType.tamilNadu,
      StateType.tripura,
      StateType.rajasthan,
      StateType.westBengal,
      StateType.madhyaPradesh,
      StateType.himachalPradesh,
      StateType.haryana,
      StateType.bihar,
      StateType.goa,
    ];
  }
}
